export default __webpack_public_path__ + "static/media/tradebrain.7af82d2f.svg";